// extracted by mini-css-extract-plugin
export default {"container":"ApiGuide_container__cpZSu","gap":"ApiGuide_gap__ZiKQA","bg":"ApiGuide_bg__XgXyJ"};